var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8H3.5V20H6.5V8Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 8C2.75 7.58579 3.08579 7.25 3.5 7.25H6.5C6.91421 7.25 7.25 7.58579 7.25 8V20C7.25 20.4142 6.91421 20.75 6.5 20.75H3.5C3.08579 20.75 2.75 20.4142 2.75 20V8ZM4.25 8.75V19.25H5.75V8.75H4.25Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4H10.5V20H13.5V4Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 4C9.75 3.58579 10.0858 3.25 10.5 3.25H13.5C13.9142 3.25 14.25 3.58579 14.25 4V20C14.25 20.4142 13.9142 20.75 13.5 20.75H10.5C10.0858 20.75 9.75 20.4142 9.75 20V4ZM11.25 4.75V19.25H12.75V4.75H11.25Z",
    fill: "#1C1B1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11H17.5V20H20.5V11Z",
    fill: "#1C1B1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 11C16.75 10.5858 17.0858 10.25 17.5 10.25H20.5C20.9142 10.25 21.25 10.5858 21.25 11V20C21.25 20.4142 20.9142 20.75 20.5 20.75H17.5C17.0858 20.75 16.75 20.4142 16.75 20V11ZM18.25 11.75V19.25H19.75V11.75H18.25Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.d4e96bdb.svg";
export { ForwardRef as ReactComponent };